// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"App_mainDiv__3Jel7"};